export enum ResourceType {
  FILE = 'FILE',
  TEMPORARY = 'TEMPORARY',
  VIDEO = 'VIDEO',
  YOUTUBE = 'YOUTUBE',
}
